import { Link, useLocation } from 'react-router-dom';
import { ShoppingCart, Users } from 'lucide-react';

export function EducatoreAreaSwitcher() {
  const location = useLocation();
  const isInShop = location.pathname.startsWith('/shop');
  const target = isInShop ? '/educatori/ra' : '/shop';
  const label = isInShop ? 'Elenco RA' : 'Shop';
  const Icon = isInShop ? Users : ShoppingCart;

  return (
    <Link
      to={target}
      className="flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium rounded-full border border-border bg-background hover:bg-accent hover:border-primary transition-colors"
    >
      <Icon className="h-3.5 w-3.5" />
      {label}
    </Link>
  );
}
